<tui-root
  nodaChangeLangAttr
  class="assets-content"
>
  <router-outlet />
</tui-root>
